import { type PreloadedState } from '@reduxjs/toolkit';

import { type TReduxState, type TReduxStore, createReduxStore } from '@/microfrontends/filters/shared/store';
import { type IApplicationContext } from '@/microfrontends/filters/shared/types/applicationContext';
import { setCoworkingTotalAreaFilterEnabled } from '@/microfrontends/filters/shared/utils/rs/coworkingTotalAreaFilterEnabled';

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const {
    config,
    custom: { isTestMode },
  } = context;

  const initialState = config.getStrict<PreloadedState<TReduxState>>('filters.initialState');

  /**
   * @todo удалить строчку с кодом
   * @description данная функциональность была добавлена в задаче CD-135759, будет удалена в CD-136055
   * @link https://jira.cian.tech/browse/CD-136055
   */
  setCoworkingTotalAreaFilterEnabled(!!config.get('search-frontend.CoworkingTotalAreaFilter.Enabled'));

  return createReduxStore(context, initialState, isTestMode);
}
